import { Navigate } from 'react-router';

import { ACCOUNT_ROUTES } from '@/features/account/paths';
import { PERMISSIONS } from '@/shared/permissions/permissions';
import { usePermissions } from '@/shared/permissions/usePermissions';

/**
 * DEF-035 — where the old Purchasing nodes address, `/organization/branches`,
 * leads now that the separate page is gone (client instruction, 9 October 2026).
 *
 * A reader who may see purchasing units goes to them: that is the one place a
 * purchasing place is set up. Anybody else would land on a page that refuses to
 * load its list, so they go to their own profile, which names the purchasing
 * units they work for ("Where you work"). The test is the right the menu shows
 * the Purchasing units entry for; nobody is offered anything they could not
 * already open.
 */
export function OldBranchesAddress() {
  const { can } = usePermissions();

  return (
    <Navigate
      to={
        can(PERMISSIONS.purchasingUnitView)
          ? '/admin/purchasing-units'
          : ACCOUNT_ROUTES.tenant.profile
      }
      replace
    />
  );
}
